import { render, staticRenderFns } from "./ModalTrazabilidad.vue?vue&type=template&id=471d3264&scoped=true"
import script from "./ModalTrazabilidad.vue?vue&type=script&lang=js"
export * from "./ModalTrazabilidad.vue?vue&type=script&lang=js"
import style0 from "./ModalTrazabilidad.vue?vue&type=style&index=0&id=471d3264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471d3264",
  null
  
)

export default component.exports